import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DiagramModel from 'src/model/diagram.model';

// TODO: Implement a better callback to detect when all images
// are loaded. For the moment it's using a setTimeout hoping
// everything is loaded after 800ms
// Possible: https://www.npmjs.com/package/react-on-images-loaded

interface IModelPrintViewProps {
  diagrams: DiagramModel[];
  closeWindow: () => void;
  t?: any;
}

const WAIT_FOR_IMAGES = 600;
const TD_STYLE: React.CSSProperties = {
  lineHeight: '24px',
  fontSize: '20px',
  color: 'rgba(0, 0, 0, 0.87)'
};
const TABLE_STYLE: React.CSSProperties = {
  breakAfter: 'page',
  width: '100%'
};
const THEAD_STYLE: React.CSSProperties = {
  color: '#14447d',
  fontWeight: 'bold',
  lineHeight: '24px',
  fontSize: '18px',
  textAlign: 'left'
};
const FIGURE_STYLE: React.CSSProperties = {
  breakInside: 'avoid',
  breakAfter: 'page'
};

class ModelPrintView extends React.PureComponent<IModelPrintViewProps, any> {
  private printWindow: Window;
  private container: HTMLDivElement;

  public render() {
    if (!this.container) {
      return null;
    }

    return ReactDOM.createPortal(this.getDiagrams(), this.container);
  }

  public componentWillMount() {
    this.printWindow = window.open('', '', 'width=800,height=600');
    const document = this.printWindow.document;

    this.container = document.createElement('div');
    document.body.appendChild(this.container);
    document.title = 'Print Diagram';
  }

  public componentDidMount() {
    this.printWindow.addEventListener('beforeunload', () => {
      this.props.closeWindow();
    });

    //  TODO (see above)
    setTimeout(() => {
      this.printWindow.print();
    }, WAIT_FOR_IMAGES);
  }

  public componentWillUnmount() {
    this.printWindow.close();
  }

  private getDiagrams() {
    const { diagrams, t } = this.props;

    // Styles are inline because the application styles are not
    // attached when creating a new window.
    return diagrams.map(diagram => (
      <div className="rp-print-view-model" key={diagram.diagramId}>
        <figure className="rp-testing" style={FIGURE_STYLE}>
          <img src={diagram.urlDiagram} width="100%" alt="Model" />
        </figure>
        <table style={TABLE_STYLE}>
          <thead style={THEAD_STYLE}>
            <tr>
              <th>{t('partClaim.referenceNumber')} </th>
              <th>{t('myReturns.partNumber')}</th>
              <th>{t('myOrders.description')}</th>
            </tr>
          </thead>
          <tbody>
            {diagram.products.map(product => (
              <tr key={product.id}>
                <td style={TD_STYLE}>{product.diagramReferenceNumber}</td>
                <td style={TD_STYLE}>{product.productNumber}</td>
                <td style={TD_STYLE}>{product.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ));
  }
}

export default ModelPrintView;
